<template>
  <section
    :id="ANCHORS.BECOME_BOUTIQUE"
    class="become_boutique"
  >
    <div class="osk-wrapper">
      <div class="flex_block">
        <div class="left_block_text">
          <div class="title_block_sm">
            {{ $t('components.info.becomeBoutique.title') }}
          </div>

          <p>
            {{ $t('components.info.becomeBoutique.text1') }}
          </p>

          <p>{{ $t('components.info.becomeBoutique.text2') }}</p>
        </div>

        <div class="right_form_block">
          <div
            v-if="!dataSent"
            class="form_block"
          >
            <form>
              <div class="inp_block">
                <UikitFormInput
                  v-model="name"
                  name="name"
                  :label="$t('components.info.becomeBoutique.name')"
                  placeholder=" "
                  class="name"
                  required
                />
              </div>

              <div class="inp_block">
                <UikitFormInput
                  v-model="phone"
                  name="phone"
                  :label="$t('components.info.becomeBoutique.phone')"
                  :placeholder="isInternational ? '+971 (_)-___-____' : '+7 (___)-___-__-__'"
                  :mask="isInternational ? '+971 (#)-###-####' : '+7 (###)-###-##-##'"
                  class="phone_mask_new phone"
                  required
                />
              </div>

              <div class="inp_block">
                <UikitFormInput
                  v-model="description"
                  name="description"
                  :label="$t('components.info.becomeBoutique.description')"
                  placeholder=" "
                  class="description"
                  textarea
                />
              </div>

              <div class="inp_block_submit">
                <UikitButton
                  full-width
                  size="m"
                  @click="sendForm($event)"
                >
                  {{ $t('common.send') }}
                </UikitButton>
              </div>
            </form>
          </div>

          <div
            v-else
            class="thanks_block"
          >
            <div class="icon">
              <UIIcon name="check-big" />
            </div>

            <p>
              {{ $t('components.info.becomeBoutique.successMessage') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ANCHORS } from '~/components/info/anchors';
import { Common } from '~/restAPI/Common';
import { useApi } from '~/restAPI';

const name = ref('');
const phone = ref('');
const description = ref('');
const dataSent = ref(false);

const { t } = useI18n();
const { createApiInstance } = useApi();
const { showErrorDialog } = useErrorDialog();
const { isInternational } = useInternational();

const commonApi = createApiInstance(Common);

function sendForm(e: Event) {
  e.preventDefault();

  if (!name.value || !phone.value) return;

  commonApi.sendProStatusRequestMailUsingPost({
    name: name.value,
    phone: phone.value,
    description: description.value,
  }, { format: 'json' })
    .then(() => {
      dataSent.value = true;
    })
    .catch((error) => showErrorDialog({
      title: t('common.error'),
      subtitle: t('common.error.requestError'),
    }));
}
</script>

<style scoped lang="scss">
section.become_boutique {
  background: #FAFAFA;
  padding: 85px 0 80px;
  border-top: 1px solid rgba(51, 51, 51, 0.1);
}

section.become_boutique .flex_block {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

section.become_boutique .flex_block .left_block_text {
  width: calc(100% - 430px);
  max-width: 490px;
}

section.become_boutique .flex_block .left_block_text p {
  margin-top: 26px;
  line-height: 26px;
  font-size: 16px;
}

section.become_boutique .flex_block .right_form_block {
  width: 414px;
  margin-right: 60px;
}

section.become_boutique .flex_block .right_form_block .form_block {
  padding: 33px 30px;
  background: #ffffff;
}

section.become_boutique .flex_block .right_form_block .form_block .inp_block {
  margin-bottom: 23px;
}

section.become_boutique .flex_block .right_form_block .form_block .inp_block span {
  font-size: 14px;
  display: block;
  margin-bottom: 10px;
}

section.become_boutique .flex_block .right_form_block .form_block .inp_block textarea,
section.become_boutique .flex_block .right_form_block .form_block .inp_block input {
  width: 100%;
  height: 42px;
  border: 1px solid #E5E5E5;
  outline: none;
  border-radius: 2px;
}

section.become_boutique .flex_block .right_form_block .form_block .inp_block textarea {
  resize: none;
  height: 140px;
}

section.become_boutique .flex_block .right_form_block .form_block .inp_block_submit {
  margin-top: 30px;
}

section.become_boutique .flex_block .right_form_block .thanks_block {
  padding: 87px 52px 52px;
  text-align: center;
  background: #ffffff;
}

section.become_boutique .flex_block .right_form_block .thanks_block svg {
  display: inline-block;
}

section.become_boutique .flex_block .right_form_block .thanks_block p {
  font-size: 14px;
  line-height: 21px;
  margin-top: 30px;
}

@media only screen and (max-width: 1200px) {
  section.become_boutique .flex_block .right_form_block {
    margin-right: 0;
  }
}

@media only screen and (max-width: 1024px) {
  section.become_boutique {
    padding: 60px 0;
  }

  section.become_boutique .flex_block {
    display: block;
  }

  section.become_boutique .flex_block .left_block_text {
    width: 100%;
    max-width: 100%;
  }

  section.become_boutique .flex_block .left_block_text p {
    margin-top: 28px;
  }

  section.become_boutique .flex_block .right_form_block {
    width: 100%;
    margin-top: 47px;
  }

  section.become_boutique .flex_block .right_form_block .thanks_block {
    padding: 87px 52px 71px;
  }

  section.become_boutique .flex_block .right_form_block .thanks_block p {
    line-height: 18px;
  }
}

@media only screen and (max-width: 767px) {
  section.become_boutique {
    padding: 41px 0;
  }

  section.become_boutique .flex_block .left_block_text p {
    margin-top: 12px;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 22px;
  }

  section.become_boutique .flex_block .left_block_text p:last-child {
    margin-bottom: 0;
  }

  section.become_boutique .flex_block .right_form_block {
    margin-top: 30px;
  }

  section.become_boutique .flex_block .right_form_block .form_block {
    padding: 33px 16px;
  }

  section.become_boutique .flex_block .right_form_block .thanks_block {
    padding: 56px 30px 71px;
  }

  section.become_boutique .flex_block .right_form_block .thanks_block p {
    line-height: 22px;
  }

  section.become_boutique .flex_block .right_form_block .thanks_block p br {
    display: none;
  }
}
</style>
